import React from "react";

import { IShowElementExercise } from "@eagerdog/interfaces";

import styles from "./ExerciseItem.module.scss";

interface IProps {
  index: number,
  exercise: IShowElementExercise,
  variant: "available" | "selected",
  onRemove(): void,
  allowRemove?: boolean
}

const ExerciseItem: React.FC<IProps> = (props) => {
  const isSelected = props.variant === "selected";

  return (
    <div className={isSelected ? `${styles.ExerciseItem} ${styles.selected}` : `${styles.ExerciseItem} ${styles.available}`}>
      <div className={styles.handleWrap}>
        <div className={`${styles.handle} ${styles.icon}`}>
        </div>
      </div>
      <div className={styles.details}>
        {props.exercise.sign
          ? <span className={styles.sign}>({props.exercise.sign})</span>
          : (isSelected && <span className={styles.index}>{props.index + 1}. </span>)}
        <span className={styles.name}>{props.exercise.exercise}</span>
      </div>
      {isSelected && props.allowRemove !== false && (
        <button
          type="button"
          className={styles.remove}
          aria-label={`Remove ${props.exercise.exercise}`}
          onClick={() => { props.onRemove(); }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default ExerciseItem;
